var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSitOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3457,
    y: 0.75,
    width: 28.5,
    height: 17.5,
    rx: 8.75,
    fill: "#333333",
    stroke: "#E0E0E0",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5957,
    y: 3,
    width: 24,
    height: 13,
    rx: 6.5,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4013,
    y: 9.75184,
    width: 14.3889,
    height: 14.3889,
    rx: 7.19444,
    fill: "#1CEC80",
    stroke: "#333333",
    strokeWidth: 1.61111
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5957 13.9463H22.9957V19.9463H22.5957V13.9463ZM26.1957 13.9463H26.5957V19.9463H26.1957V13.9463Z",
    stroke: "#222627",
    strokeWidth: 1.61111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitOut);
export default __webpack_public_path__ + "static/media/sitOut.ffc9f43c08a45de8851f6f2f11599d54.svg";
export { ForwardRef as ReactComponent };